import type { HttpTransport } from '@mangovoice/api-client'
import type { components } from '@mangovoice/types/generated/mango-api'

export type SystemSettings = components['schemas']['SystemSettings']

/**
 * System Settings resource.
 * Exposes both the direct endpoint methods and a pass-through
 * for the @mangovoice/system-settings-ui library adapter.
 */
export function createSystemSettingsResource(transport: HttpTransport) {
  return {
    getSystemSettings: <T>(pbxId: number) =>
      transport.get<T>(`/app/v1/pbx/${pbxId}/system-settings/`),

    updateSystemSettings: (pbxId: number, data: Record<string, unknown>) =>
      transport.patch<SystemSettings>(
        `/app/v1/pbx/${pbxId}/system-settings/`,
        data,
      ),

    /** Pass-through transport for @mangovoice/system-settings-ui adapter */
    transport: {
      get: <T>(url: string, params?: Record<string, unknown>) =>
        transport.get<T>(url, params),
      patch: <T>(url: string, data?: unknown) => transport.patch<T>(url, data),
    },
  }
}
